
import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[appGooglePlacesAutocomplete]'
})
export class AutocompleteDirective {
  @Output() onSelect: EventEmitter<google.maps.places.PlaceResult> = new EventEmitter();

  private autocomplete: google.maps.places.Autocomplete;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.initAutocomplete();
  }

  private initAutocomplete() {
    debugger
    this.autocomplete = new google.maps.places.Autocomplete(
      this.el.nativeElement,
      {
        types: ['geocode'] // 'geocode' for addresses, 'establishment' for businesses
      }
    );

    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      if (place.geometry) {
        this.onSelect.emit(place);
      }
    });
  }
}